import React, { FC } from 'react';
import styles from './Accessibility.module.scss';
import {Helmet} from "react-helmet";


interface AccessibilityProps {}

const Accessibility: FC<AccessibilityProps> = () => (
    <><Helmet>
        <meta charSet="utf-8"/>
        <title>Accessibility</title>
    </Helmet>
        <div className={styles.Accessibility}>
            <div className="standard-margin">
                <h1>TIC Accessibility</h1>
                <hr></hr>
                <div>
                    <h2 className="subhead">Accessibility Statement</h2>
                    <p>The National Park Service (<abbr>NPS</abbr>) is committed to making its electronic and
                        information
                        technologies accessible to the widest possible audience, including individuals with
                        disabilities.
                        <abbr>NPS</abbr> regularly monitors its sites to ensure that they meet the requirements of
                        Section
                        508 of the Rehabilitation Act (29 U.S.C. 794d), as amended in 1998, and the W3C Web Content
                        Accessibility Guidelines.</p>

                    <h2 className="subhead" id="Cont">TIC Section 508 Contact Information:</h2>
                    <p><span className="emphaText">By chat:</span> <a
                        href="https://teams.microsoft.com/l/team/19%3a34e72619e8fd4dd19b7327a3d0ade5d2%40thread.skype/conversations?groupId=a76d698b-c933-4449-8211-b40058fe083d&amp;tenantId=0693b5ba-4b18-4d7b-9341-f32f400a5494"
                        id="anch_36">eTIC Chat</a></p>
                    <p><span className="emphaText">By email:</span> <a href="mailto:etic@nps.gov"
                                                                       id="anch_37">etic@nps.gov</a></p>
                    <p><span className="emphaText">By mail:</span><br></br>
                        DSC, Technical Information Center<br></br>
                        National Park Service<br></br>
                        One Denver Federal Center Building 50<br></br>
                        Denver, CO 80225-0047<br></br></p>
                    <p><span className="emphaText">By telephone:</span> 303-969-2130</p>

                    <h2 className="subhead">Alternate Access to Web Information</h2>
                    <p>If the format of any material on our website interferes with your ability to access the
                        information, please <a href="#Cont" id="anch_38">contact us</a> at the address above.</p>
                    <p>To allow us to respond in a manner most helpful to you, please provide the following
                        information:</p>
                    <ol>
                        <li>Nature of your accessibility issue.</li>
                        <li>Preferred format in which to receive the material.</li>
                        <li>Web address (<abbr>URL</abbr>) of the material with which you are having difficulty.</li>
                        <li>Your contact information.</li>
                    </ol>

                    <h2 className="subhead"><abbr>HTML</abbr> and Image Accessibility</h2>
                    <p>Generally, we use Hypertext Markup Language (<abbr>HTML</abbr>). In
                        creating <abbr>HTML</abbr> documents, we follow Section 508 standards; for example, we include
                        alternate text to describe graphics.</p>

                    <h2 className="subhead">Adobe Acrobat<sup>®</sup> Reader and <abbr>PDF</abbr> Files</h2>

                    <p>Our website also contains documents in Portable Document Format (<abbr>PDF</abbr>).
                        Most <abbr>PDF</abbr> files will be accessible to those who use assistive technology such as
                        screen readers.
                        Some legacy or software-created <abbr>PDF</abbr> files may not be accessible. If you are
                        experiencing difficulty reading any <abbr>PDF</abbr> file, please <a href="#Cont" id="anch_39">contact
                            us</a>, and we will send you an alternate version.</p>
                    <ul>
                        <li><abbr>PDF</abbr> files require the <a
                            href="https://get.adobe.com/reader/" target="_blank" id="anch_40">Adobe Acrobat
                            Reader</a> (free download).
                        </li>
                        <li>Adobe also provides free <abbr>PDF</abbr> <a
                            href="https://www.adobe.com/accessibility/products/reader.html" target="_blank"
                            id="anch_41">tools
                            for the visually impaired</a>.
                        </li>
                    </ul>
                    <p>For detailed, up-to-date information about Acrobat Reader or the <abbr>PDF</abbr> format,
                        visit <a
                            href="https://www.adobe.com/#" target="_blank" id="anch_42">Adobe Systems Inc.</a></p>

                    <h2 className="subhead">Resources</h2>
                    <p>Section 508 is a Federal law that requires agencies to provide individuals with disabilities
                        equal
                        access to electronic information and data comparable to those who do not have disabilities,
                        unless
                        an undue burden would be imposed on the agency.
                        The Section 508 standards are the technical requirements and criteria that are used to measure
                        conformance within this law. More information on Section 508 and the technical standards can be
                        found on the following sites:</p>

                    <ul>
                        <li><a href="https://section508.gov/" target="_blank" id="anch_43">Section
                            508.gov</a> provides Federal employees and the public with access to resources for
                            understanding and implementing the requirements of Section 508, including Section 508 tools,
                            resources, standards, and news.
                        </li>
                        <li>The <a href="https://www.access-board.gov/" target="_blank"
                                   id="anch_44">U.S. Access Board</a> has several articles to
                            provide information on Section 508 law, frequently asked questions, and standards.
                        </li>
                        <li>The <a href="https://www.w3.org/WAI/" target="_blank" id="anch_45">Web
                            Accessibility Initiative</a> <abbr>(WAI)</abbr> website provides strategies, guidelines, and
                            resources to make the Web accessible to people with disabilities.
                        </li>
                    </ul>
                </div>
                <br></br> <br></br> <br></br>
            </div>
        </div>
    </>

);

export default Accessibility;
